import { createLabeledMessages } from '../../../messageUtils';
const logout = {
    logout: 'Byli jste odhlášeni z aplikace',
    logAgain: 'Znovu přihlásit',
    confirmLogout: 'Budete přesměrování na odhlašovací obrazovku a vaše session bude invalidována.'
};
export default Object.assign({}, logout, createLabeledMessages(logout));
